import { render, staticRenderFns } from "./ButtonPanel.vue?vue&type=template&id=973c1636&scoped=true&"
import script from "./ButtonPanel.vue?vue&type=script&lang=js&"
export * from "./ButtonPanel.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPanel.vue?vue&type=style&index=0&id=973c1636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973c1636",
  null
  
)

export default component.exports